module.exports = __webpack_public_path__ + "media/src/application/images/messenger-ab660a45a7e07ec7fc3c179da14ff748.svg";